import { publishReplay, refCount } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import {Injectable} from '@angular/core';
import {HttpClientService} from '../httpClient/httpclient.service';
import {EntityModel, EntitySummaryModel} from '../../models/entity.model';

@Injectable()
export class EntityService {

  public baseUrl = 'koncentro-common'
  //list: EntitySummaryModel[];
  //editing: EntityModel;

  private cachedFields: Observable<any>;

  constructor (private h: HttpClientService) {

  }

  getList() {
    return this.h.get(`/${this.baseUrl}/entities`)
      .map(res => {
        //this.list = res;
        return res;
      })
  }

  get(id: number) {
    return this.h.get(`/${this.baseUrl}/entities/${id}`)
      .map(res => {
        //this.editing = res;
        return res;
      })
  }

  post(entity: EntityModel) {
    return this.h.post(`/${this.baseUrl}/entities`, entity)
      .map(data => {

      })
  }

  put(id: number, entity: EntityModel) {

    return this.h.put(`/${this.baseUrl}/entities/${id}` , entity)
      .map(data => {

      })
  }


  delete (id: number) {
    return this.h.delete(`/${this.baseUrl}/entities/` + id)
      .map(res => {

      })
  }
  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get('/koncentro-common/schema/EntityDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/entity/entity.service.ts